export enum StatusCode {
  ACTIVE = 100,
  PENDING = 500,
}
